<template>
  <v-container class="fill-height justify-center" fluid>
   
    <offline @detected-condition="handleConnectivityChange">
      </offline>


    <v-row align="center" justify="center" class="ac fs18px">
      <v-col>
        <h1 class="mb20px">Thank you for your enquiry</h1>
        <div>Your enquiry has been sent successfully.</div>
        <div class="mt30px">
          <v-btn @click="redirectToHome()" color="primary" dark x-large tile depressed class="text-capitalize fw300 btn-big">+ Create New Enquiry</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import offline from "v-offline";

export default {
  name: "ThankYou",
  components: {
    offline
  },
  data: () => ({
    connectionStatus: false
  }),
  async created() {},
  methods: {
	redirectToHome(){
		window.location.href = "/home";
	},
    handleConnectivityChange(status) {
      this.connectionStatus = status;
      console.log("this.connectionStatus is", this.connectionStatus);
    }
  }
};
</script>
